// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Search Results Header Section
--------------------------------------------------------------*/
.TrUl78eOLJ9qk9fFq3Gm {
  padding-bottom: 0 !important;
}
.TrUl78eOLJ9qk9fFq3Gm .VsluI6pZneBeEYi5h5qU {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}
.TrUl78eOLJ9qk9fFq3Gm .VsluI6pZneBeEYi5h5qU .hr6anfKUfzs8stbTbdfs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.TrUl78eOLJ9qk9fFq3Gm .VsluI6pZneBeEYi5h5qU .nB1J0zvMWNjMOzsl9SdQ {
  display: inline-flex;
  align-items: center;
  background-color: #EBEEF2;
  color: #0C3058;
  font-size: 16px;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.3s ease;
}
.TrUl78eOLJ9qk9fFq3Gm .VsluI6pZneBeEYi5h5qU .nB1J0zvMWNjMOzsl9SdQ i {
  margin-right: 0.3rem;
}
.TrUl78eOLJ9qk9fFq3Gm .VsluI6pZneBeEYi5h5qU .nB1J0zvMWNjMOzsl9SdQ i:before {
  font-size: 1rem;
  vertical-align: middle;
  color: #0C3058;
  font-weight: 500 !important;
}
.TrUl78eOLJ9qk9fFq3Gm .seperator-bar {
  width: 1px;
  height: 26px;
  background-color: #BBBBCB;
  margin-right: 15px;
  margin-left: 15px;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .STSNIkk0MJyXKRm0tnhx {
  display: flex;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .IoGw4fqx8WDxnwfSE1w9 div {
  margin-bottom: 0;
  font-size: 16px;
  color: #0C3058;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .pRs30XjPONd6qxZckkcZ {
  display: flex;
  align-items: center;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .control-label {
  font-size: 0.95rem;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  margin-right: 0.5rem;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .cjAn8VnpTn37G4xMYLqA {
  display: flex;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ {
  display: flex;
  align-items: center;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .dropdown-menu,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .dropdown-menu {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .vpz1Xmtv02Jc17mfeQAi,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .vpz1Xmtv02Jc17mfeQAi {
  color: #0C3058;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .vpz1Xmtv02Jc17mfeQAi:focus,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .vpz1Xmtv02Jc17mfeQAi:focus {
  box-shadow: none;
  outline: none;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .vpz1Xmtv02Jc17mfeQAi span,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .vpz1Xmtv02Jc17mfeQAi span {
  font-weight: 500;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .vpz1Xmtv02Jc17mfeQAi i,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .vpz1Xmtv02Jc17mfeQAi i {
  font-size: 10px;
  color: #0C3058;
  padding: 5px;
  bottom: 1px;
  position: relative;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .vpz1Xmtv02Jc17mfeQAi i::before,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .vpz1Xmtv02Jc17mfeQAi i::before {
  display: inline-block;
  transition: transform 0.3s ease;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo.show .vpz1Xmtv02Jc17mfeQAi i::before,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ.show .vpz1Xmtv02Jc17mfeQAi i::before {
  transform: rotate(180deg);
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .hg3YeHDAT4zl4fIH5Txm,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .hg3YeHDAT4zl4fIH5Txm {
  color: #0C3058;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .hg3YeHDAT4zl4fIH5Txm:focus,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .hg3YeHDAT4zl4fIH5Txm:focus {
  box-shadow: none;
  outline: none;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .hg3YeHDAT4zl4fIH5Txm span,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .hg3YeHDAT4zl4fIH5Txm span {
  font-weight: 500;
  padding-right: 2px;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .hg3YeHDAT4zl4fIH5Txm i,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .hg3YeHDAT4zl4fIH5Txm i {
  font-size: 9px;
  color: #0C3058;
  padding: 5px;
  bottom: 1px;
  position: relative;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .hg3YeHDAT4zl4fIH5Txm i::before,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .hg3YeHDAT4zl4fIH5Txm i::before {
  display: inline-block;
  transition: transform 0.3s ease;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo.show .hg3YeHDAT4zl4fIH5Txm i::before,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ.show .hg3YeHDAT4zl4fIH5Txm i::before {
  transform: rotate(180deg);
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .GX0OeVRz9an1_JaeTe7R,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .GX0OeVRz9an1_JaeTe7R {
  position: relative;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .GX0OeVRz9an1_JaeTe7R::after,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .GX0OeVRz9an1_JaeTe7R::after {
  content: "\\f282";
  /* Bootstrap Icons chevron-down */
  font-family: "bootstrap-icons";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 0.8rem;
  color: var(--heading-color);
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: none;
  border: none;
  color: var(--heading-color);
  font-weight: 500;
  font-size: 0.95rem;
  padding: 0.25rem 1.5rem 0.25rem 1rem;
  cursor: pointer;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH:focus,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH:focus {
  outline: none;
  box-shadow: none;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH option,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ .GX0OeVRz9an1_JaeTe7R .sEO42WA0Se5xRj9ydGAH option {
  background-color: var(--surface-color);
  color: var(--default-color);
  padding: 1rem;
  font-size: 0.9rem;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD {
  margin-left: 16px;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 {
  display: flex;
  gap: 0.5rem;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0 {
  border: 0;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 6px 4px;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0:hover,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0:hover {
  color: #0068F5;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0:hover svg,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0:hover svg {
  fill: #0068F5;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0.YBrx0zUxqjhKUtLwAy0w,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0.YBrx0zUxqjhKUtLwAy0w {
  color: #0068F5;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0.YBrx0zUxqjhKUtLwAy0w svg,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0.YBrx0zUxqjhKUtLwAy0w svg {
  fill: #0068F5;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0 svg,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0 svg {
  fill: #000000;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .Rr_ZIwz7FohccF6hwhA0 i,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .Rr_ZIwz7FohccF6hwhA0 i {
  font-size: 1rem;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .FHRLp1U51KnO_FgX9y2C,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .FHRLp1U51KnO_FgX9y2C {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px;
  height: 32px;
  border-radius: 6px;
  background-color: transparent;
  border: 1px solid #BBBBCB;
  color: #0C3058;
  padding: 4px 10px 4px 12px;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .FHRLp1U51KnO_FgX9y2C svg,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .FHRLp1U51KnO_FgX9y2C svg {
  fill: #0C3058;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .FHRLp1U51KnO_FgX9y2C:hover,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .FHRLp1U51KnO_FgX9y2C:hover {
  background-color: transparent;
  color: #0068F5;
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .FHRLp1U51KnO_FgX9y2C.YBrx0zUxqjhKUtLwAy0w,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .FHRLp1U51KnO_FgX9y2C.YBrx0zUxqjhKUtLwAy0w {
  background-color: transparent;
  color: var(--contrast-color);
}
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD .FHRLp1U51KnO_FgX9y2C i,
.TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .wa8iI2LLRPXbelEc10P3 .FHRLp1U51KnO_FgX9y2C i {
  font-size: 1rem;
}
@media (max-width: 991.98px) {
  .TrUl78eOLJ9qk9fFq3Gm .IoGw4fqx8WDxnwfSE1w9 {
    font-weight: 500;
  }
  .TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .U2LyrRvHnXLYSrwOeVXe {
    display: flex;
  }
}
@media (max-width: 767.98px) {
  .TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .oUXgXJ37CZZHD7ld2NAD {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .iGHKtUTayIWAn2NA9Xyo,
  .TrUl78eOLJ9qk9fFq3Gm .LT1BkDm4a25BkMG60HSl .dbpg7DJNMsXkSCeR15AQ {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchResults/resultsHeader/ResultsHeader.module.scss"],"names":[],"mappings":"AAAA;;+DAAA;AAGA;EACI,4BAAA;AACJ;AACI;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AACR;AACQ;EACI,aAAA;EACA,eAAA;EACA,WAAA;AACZ;AAEQ;EACI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAAZ;AAEY;EACI,oBAAA;AAAhB;AAEgB;EACI,eAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;AAApB;AAMI;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AALR;AAOQ;EACI,aAAA;AALZ;AASY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAPhB;AAWQ;EACI,aAAA;EACA,mBAAA;AATZ;AAYQ;EACI,kBAAA;EACA,gEAAA;EACA,oBAAA;AAVZ;AAaQ;EACI,aAAA;AAXZ;AAcQ;;EAEI,aAAA;EACA,mBAAA;AAZZ;AAcY;;EACI,0CAAA;AAXhB;AAcY;;EACI,cAAA;AAXhB;AAagB;;EACI,gBAAA;EACA,aAAA;AAVpB;AAagB;;EACI,gBAAA;AAVpB;AAagB;;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAVpB;AAYoB;;EACI,qBAAA;EACA,+BAAA;AATxB;AAcY;;EACI,yBAAA;AAXhB;AAcY;;EACI,cAAA;AAXhB;AAagB;;EACI,gBAAA;EACA,aAAA;AAVpB;AAagB;;EACI,gBAAA;EACA,kBAAA;AAVpB;AAagB;;EACI,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAVpB;AAYoB;;EACI,qBAAA;EACA,+BAAA;AATxB;AAcY;;EACI,yBAAA;AAXhB;AAcY;;EACI,kBAAA;AAXhB;AAagB;;EACI,gBAAA;EACA,iCAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;EACA,2BAAA;AAVpB;AAagB;;EACI,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAVpB;AAYoB;;EACI,aAAA;EACA,gBAAA;AATxB;AAYoB;;EACI,sCAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AATxB;AAeQ;EACI,iBAAA;AAbZ;AAgBQ;;EAEI,aAAA;EACA,WAAA;AAdZ;AAgBY;;EACI,SAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAbhB;AAegB;;EACI,cAAA;AAZpB;AAcoB;;EACI,aAAA;AAXxB;AAegB;;EACI,cAAA;AAZpB;AAcoB;;EACI,aAAA;AAXxB;AAegB;;EACI,aAAA;AAZpB;AAegB;;EACI,eAAA;AAZpB;AAgBY;;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,0BAAA;AAbhB;AAegB;;EACI,aAAA;AAZpB;AAegB;;EACI,6BAAA;EACA,cAAA;AAZpB;AAegB;;EACI,6BAAA;EACA,4BAAA;AAZpB;AAegB;;EACI,eAAA;AAZpB;AAqBI;EACI;IACI,gBAAA;EAnBV;EAyBU;IACI,aAAA;EAvBd;AACF;AA2BI;EAEQ;IACI,aAAA;EA1Bd;AACF;AAuCI;EAKQ;;IAEI,cAAA;EAzCd;AACF","sourcesContent":["/*--------------------------------------------------------------\r\n# Search Results Header Section\r\n--------------------------------------------------------------*/\r\n.search-results-header {\r\n    padding-bottom: 0 !important;\r\n    // Active Filters\r\n    .active-filters {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 0.5rem;\r\n        margin-bottom: 1.25rem;\r\n\r\n        .filter-tags {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 0.5rem;\r\n        }\r\n\r\n        .filter-tag {\r\n            display: inline-flex;\r\n            align-items: center;\r\n            background-color: #EBEEF2;\r\n            color: #0C3058;\r\n            font-size: 16px;\r\n            padding: 0.5rem 1rem;\r\n            border-radius: 50px;\r\n            font-weight: 400;\r\n            text-decoration: none;\r\n            transition: all 0.3s ease;\r\n\r\n            i {\r\n                margin-right: 0.3rem;\r\n\r\n                &:before {\r\n                    font-size: 1rem;\r\n                    vertical-align: middle;\r\n                    color: #0C3058;\r\n                    font-weight: 500 !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    :global(.seperator-bar) {\r\n        width: 1px;\r\n        height: 26px;\r\n        background-color: #BBBBCB;\r\n        margin-right: 15px;\r\n        margin-left: 15px;\r\n    }\r\n    // Results and Controls\r\n    .results-controls {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n\r\n        .results-count-wrapper {\r\n            display: flex;\r\n        }\r\n\r\n        .results-count {\r\n            div {\r\n                margin-bottom: 0;\r\n                font-size: 16px;\r\n                color: #0C3058;\r\n            }\r\n        }\r\n\r\n        .controls-wrapper {\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        :global(.control-label) {\r\n            font-size: 0.95rem;\r\n            color: color-mix(in srgb, var(--default-color), transparent 20%);\r\n            margin-right: 0.5rem;\r\n        }\r\n\r\n        .sort-view-wrapper {\r\n            display: flex;\r\n        }\r\n        // Sort Options and Items Per Page\r\n        .sort-options,\r\n        .items-per-page {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            :global(.dropdown-menu) {\r\n                box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.50);\r\n            }\r\n\r\n            .sort-label {\r\n                color: #0C3058;\r\n\r\n                &:focus {\r\n                    box-shadow: none;\r\n                    outline: none;\r\n                }\r\n\r\n                span {\r\n                    font-weight: 500;\r\n                }\r\n\r\n                i {\r\n                    font-size: 10px;\r\n                    color: #0C3058;\r\n                    padding: 5px;\r\n                    bottom: 1px;\r\n                    position: relative;\r\n\r\n                    &::before {\r\n                        display: inline-block;\r\n                        transition: transform 0.3s ease;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &:global(.show) .sort-label i::before {\r\n                transform: rotate(180deg);\r\n            }\r\n\r\n            .control-label {\r\n                color: #0C3058;\r\n\r\n                &:focus {\r\n                    box-shadow: none;\r\n                    outline: none;\r\n                }\r\n\r\n                span {\r\n                    font-weight: 500;\r\n                    padding-right: 2px;\r\n                }\r\n\r\n                i {\r\n                    font-size: 9px;\r\n                    color: #0C3058;\r\n                    padding: 5px;\r\n                    bottom: 1px;\r\n                    position: relative;\r\n\r\n                    &::before {\r\n                        display: inline-block;\r\n                        transition: transform 0.3s ease;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &:global(.show) .control-label i::before {\r\n                transform: rotate(180deg);\r\n            }\r\n\r\n            .select-wrapper {\r\n                position: relative;\r\n\r\n                &::after {\r\n                    content: \"\\F282\";\r\n                    /* Bootstrap Icons chevron-down */\r\n                    font-family: \"bootstrap-icons\";\r\n                    position: absolute;\r\n                    right: 10px;\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                    pointer-events: none;\r\n                    font-size: 0.8rem;\r\n                    color: var(--heading-color);\r\n                }\r\n\r\n                .custom-select {\r\n                    appearance: none;\r\n                    -webkit-appearance: none;\r\n                    -moz-appearance: none;\r\n                    background: none;\r\n                    border: none;\r\n                    color: var(--heading-color);\r\n                    font-weight: 500;\r\n                    font-size: 0.95rem;\r\n                    padding: 0.25rem 1.5rem 0.25rem 1rem;\r\n                    cursor: pointer;\r\n\r\n                    &:focus {\r\n                        outline: none;\r\n                        box-shadow: none;\r\n                    }\r\n\r\n                    option {\r\n                        background-color: var(--surface-color);\r\n                        color: var(--default-color);\r\n                        padding: 1rem;\r\n                        font-size: 0.9rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .view-options {\r\n            margin-left: 16px;\r\n        }\r\n        // View Options\r\n        .view-options,\r\n        .show-filters-button-wrapper {\r\n            display: flex;\r\n            gap: 0.5rem;\r\n\r\n            .view-btn {\r\n                border: 0;\r\n                background-color: transparent;\r\n                display: flex;\r\n                align-items: center;\r\n                padding: 6px 4px;\r\n\r\n                &:hover {\r\n                    color: #0068F5;\r\n\r\n                    svg {\r\n                        fill: #0068F5;\r\n                    }\r\n                }\r\n\r\n                &.active {\r\n                    color: #0068F5;\r\n\r\n                    svg {\r\n                        fill: #0068F5;\r\n                    }\r\n                }\r\n\r\n                svg {\r\n                    fill: #000000;\r\n                }\r\n\r\n                i {\r\n                    font-size: 1rem;\r\n                }\r\n            }\r\n\r\n            .show-filters-button {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                width: 70px;\r\n                height: 32px;\r\n                border-radius: 6px;\r\n                background-color: transparent;\r\n                border: 1px solid #BBBBCB;\r\n                color: #0C3058;\r\n                padding: 4px 10px 4px 12px;\r\n\r\n                svg {\r\n                    fill: #0C3058;\r\n                }\r\n\r\n                &:hover {\r\n                    background-color: transparent;\r\n                    color: #0068F5;\r\n                }\r\n\r\n                &.active {\r\n                    background-color: transparent;\r\n                    color: var(--contrast-color);\r\n                }\r\n\r\n                i {\r\n                    font-size: 1rem;\r\n                }\r\n            }\r\n\r\n            .show-filters-button {\r\n            }\r\n        }\r\n    }\r\n    // Responsive Styles\r\n    @media (max-width: 991.98px) {\r\n        .results-count {\r\n            font-weight: 500;\r\n        }\r\n        .results-controls {\r\n            .controls-wrapper {\r\n            }\r\n\r\n            .buttons-wrapper {\r\n                display: flex;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 767.98px) {\r\n        .results-controls {\r\n            .view-options {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .results-controls {\r\n            .controls-wrapper {\r\n            }\r\n\r\n            .sort-options,\r\n            .items-per-page {\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 575.98px) {\r\n        .results-controls {\r\n            .controls-wrapper {\r\n            }\r\n\r\n            .sort-options,\r\n            .items-per-page {\r\n                margin-left: 0;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-results-header": `TrUl78eOLJ9qk9fFq3Gm`,
	"active-filters": `VsluI6pZneBeEYi5h5qU`,
	"filter-tags": `hr6anfKUfzs8stbTbdfs`,
	"filter-tag": `nB1J0zvMWNjMOzsl9SdQ`,
	"results-controls": `LT1BkDm4a25BkMG60HSl`,
	"results-count-wrapper": `STSNIkk0MJyXKRm0tnhx`,
	"results-count": `IoGw4fqx8WDxnwfSE1w9`,
	"controls-wrapper": `pRs30XjPONd6qxZckkcZ`,
	"sort-view-wrapper": `cjAn8VnpTn37G4xMYLqA`,
	"sort-options": `iGHKtUTayIWAn2NA9Xyo`,
	"items-per-page": `dbpg7DJNMsXkSCeR15AQ`,
	"sort-label": `vpz1Xmtv02Jc17mfeQAi`,
	"control-label": `hg3YeHDAT4zl4fIH5Txm`,
	"select-wrapper": `GX0OeVRz9an1_JaeTe7R`,
	"custom-select": `sEO42WA0Se5xRj9ydGAH`,
	"view-options": `oUXgXJ37CZZHD7ld2NAD`,
	"show-filters-button-wrapper": `wa8iI2LLRPXbelEc10P3`,
	"view-btn": `Rr_ZIwz7FohccF6hwhA0`,
	"active": `YBrx0zUxqjhKUtLwAy0w`,
	"show-filters-button": `FHRLp1U51KnO_FgX9y2C`,
	"buttons-wrapper": `U2LyrRvHnXLYSrwOeVXe`
};
export default ___CSS_LOADER_EXPORT___;
